var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconReadBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.56 27.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_2",
    "data-name": "\\u5716\\u5C64 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_1-2",
    "data-name": "\\u5716\\u5C64 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.15,19.85h.27a15.28,15.28,0,0,1,11.5,2.67l.14.07.14.07a1.23,1.23,0,0,0,1,0l.13-.07.14-.07a15.54,15.54,0,0,1,11.64-2.81,1.45,1.45,0,0,0,1.64-1.16v-17A1.28,1.28,0,0,0,27.55.27a15.42,15.42,0,0,0-3-.27,18.12,18.12,0,0,0-8.28,2,3.39,3.39,0,0,1-3,0A17.21,17.21,0,0,0,5,.07a15,15,0,0,0-3,.27A1.4,1.4,0,0,0,.78,1.71V18.48A1.37,1.37,0,0,0,2.15,19.85ZM13.72,5.48a1,1,0,1,1,2,0V19.37a1,1,0,1,1-2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.74,27.86A3.43,3.43,0,0,1,13,27.32a17.7,17.7,0,0,0-4.1-1.92,10.43,10.43,0,0,0-7,0,1.36,1.36,0,1,1-1-2.53,13.38,13.38,0,0,1,9,0,26.2,26.2,0,0,1,4.66,2.19.54.54,0,0,0,.62,0,23.93,23.93,0,0,1,4.65-2.19,13.35,13.35,0,0,1,9,0,1.37,1.37,0,1,1-1,2.53,11.06,11.06,0,0,0-7,0,21.2,21.2,0,0,0-4.11,1.92A3.82,3.82,0,0,1,14.74,27.86Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReadBlack);
export default __webpack_public_path__ + "static/media/icon_read-black.ff915692ff6cf7f457ba7339b1569af3.svg";
export { ForwardRef as ReactComponent };